module.exports = __webpack_public_path__ + "assets/img/bergesystem-longlife.06a840fa.png";